export default function negativeValueCalculate(value){
    let actualValue = value*10 ;/*as actual value sent devided by 10 */
    let substraction = 65536-actualValue; /*65536 is constant*/
    let result_minus_value = substraction/10;

    return `-${result_minus_value}`;
}

